import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JsonEditorComponent } from './json-editor.component';
import { IconTooltipModule } from '@finder/shared/components/icon-tooltip/icon-tooltip.module';
import { TooltipModule } from '@finder/shared/components/tooltip/tooltip.module';

@NgModule({
    imports: [
        CommonModule,
        IconTooltipModule,
        TooltipModule,
    ],
    declarations: [JsonEditorComponent],
    exports: [JsonEditorComponent],
    entryComponents: [JsonEditorComponent],
})
export class JsonEditorModule {}
